import { Box, Button, Modal, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Fragment } from 'react';
import ButtonUI from '../../../../components/ui/button/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faFloppyDisk,
  faTrash,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import SwalUI from '../../../../components/ui/swal-ui/swal-ui';
import {
  svcreateSegment,
  svDeleteSegment,
  svUpdateSegment,
} from '../../../../services/productServices/productcate.service';
import { useState } from 'react';

const modalSwal = withReactContent(Swal);

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function CategryDeleteSegment(props) {
  const { t, open, setOpen, segment, setRefreshData } = props;
  const [title, setTitle] = useState('');
  const [Etitle, setEtitle] = useState(false);
  const [errorsMessage, setErrorsMessage] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editedTitle, setEditedTitle] = useState('');
  const [updateError, setUpdateError] = useState(false);
  const [updateErrorMessage, setUpdateErrorMessage] = useState('');

  const deleteHandle = (id) => {
    console.log(id);

    modalSwal
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          svDeleteSegment(id).then((res) => {
            if (res.status === 200) {
              setRefreshData((prev) => prev + 1);
              setOpen(false);
              SwalUI({
                status: res.data.status,
                description: res.data.description,
              });
              setRefreshData((prev) => prev + 1);
            } else {
              SwalUI({
                status: res.data.status,
                description: res.data.description,
              });
            }
          });
        }
      });
  };

  const handleEditClick = (row) => {
    setEditingId(row.id);
    setEditedTitle(row.title);
    setUpdateError(false);
    setUpdateErrorMessage('');
  };

  const handleCancelClick = () => {
    setEditingId(null);
  };

  const handleUpdateSegment = (id) => {
    if (editedTitle.trim() === '') {
      setUpdateError(true);
      setUpdateErrorMessage("Title can't be empty");
      return;
    }

    svUpdateSegment(id, { title: editedTitle }).then((res) => {
      if (res.status === 200) {
        setEditingId(null);
        setRefreshData((prev) => prev + 1);
        SwalUI({
          status: res.data.status,
          description: res.data.description,
        });
      } else if (res.response && res.response.status === 422) {
        setUpdateError(true);
        setUpdateErrorMessage(res.response.data.errorMessage.title[0]);
      } else {
        SwalUI({
          status: res.data.status,
          description: res.data.description,
        });
      }
    });
  };

  const columns = [
    {
      field: 'title',
      headerName: 'Segment',
      flex: 2,
      renderCell: (params) => {
        if (editingId === params.row.id) {
          return (
            <TextField
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              size="small"
              variant="standard"
              sx={{ width: '100%' }}
              autoFocus
              error={updateError}
              helperText={updateErrorMessage}
            />
          );
        }
        return params.value;
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => (
        <>
          {editingId === params.row.id ? (
            <div className="box-action">
              <Button
                sx={{ minWidth: ['55px'], fontSize: '0.675rem', backgroundColor: '#14b8a6', '&:hover': { backgroundColor: '#0d9488' } }}
                variant="contained"
                size="medium"
                onClick={() => handleUpdateSegment(params.row.id)}
              >
                <FontAwesomeIcon icon={faFloppyDisk} />
              </Button>
              {/* <ButtonUI
                onClick={() => handleUpdateSegment(params.row.id)}
                on="save"
                className="btn-custom onSave"
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                width={'xxs'}
              >
                {t('')}
              </ButtonUI> */}
              <Button
                sx={{ minWidth: ['55px'], fontSize: '0.675rem', backgroundColor: '#f43f5e', '&:hover': { backgroundColor: '#e11d48' } }}
                variant="contained"
                size="medium"
                onClick={handleCancelClick}
              >
                <FontAwesomeIcon icon={faXmark} />
              </Button>
              {/* <ButtonUI
                onClick={handleCancelClick}
                on="cancel"
                className="btn-custom onCancel"
                icon={<FontAwesomeIcon icon={faXmark} />}
                width={'xxs'}
              >
                {t('')}
              </ButtonUI> */}
            </div>
          ) : (
            <div className="box-action">
              <ButtonUI
                onClick={() => handleEditClick(params.row)}
                on="edit"
                className="btn-custom onEdit"
                icon={<FontAwesomeIcon icon={faEdit} />}
                width={'xxs'}
              >
                {t('')}
              </ButtonUI>
              <ButtonUI
                onClick={() => deleteHandle(params.row.id)}
                on="delete"
                className="btn-custom onDelete"
                icon={<FontAwesomeIcon icon={faTrash} />}
                width={'xxs'}
              >
                {t('')}
              </ButtonUI>
            </div>
          )}
        </>
      ),
    },
  ];

  const addSegmentHandle = () => {
    if (title.trim() === '') {
      console.log(Etitle);

      setEtitle(true);
    } else {
      setEtitle(false);
    }

    svcreateSegment({ title: title }).then((res) => {
      // console.log(res.description);

      if (res.status === 200) {
        SwalUI({
          status: res.data.status,
          description: res.data.description,
        });
        setTitle('');
        setRefreshData((prev) => prev + 1);
        // setOpen(false);
      }
      if (res.response.status === 422) {
        setErrorsMessage(res.response.data.errorMessage.title[0]);
        setEtitle(true);
      }
    });
  };

  return (
    <Fragment>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Segment
          </Typography>
          <Typography
            id="modal-modal-description"
            component="div"
            sx={{ mt: 2 }}
          >
            <TextField
              id="standard-basic"
              label="Standard"
              variant="standard"
              value={title}
              sx={{ width: '80%' }}
              error={Etitle}
              onChange={(e) => setTitle(e.target.value)}
              helperText={errorsMessage}
            />
            <Button variant="contained" size="small" onClick={addSegmentHandle}>
              Add
            </Button>
          </Typography>
          <Typography
            id="modal-modal-description-2"
            component="div"
            sx={{ mt: 2 }}
          >
            <DataGrid
              rows={segment}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[5, 10]}
              // checkboxSelection
              // disableRowSelectionOnClick
            />
          </Typography>
        </Box>
        {/* <Box className="category-add-modal">
          <section id="category-add-page">
            <div className="card-control">
              <div className="card-head">
                              <div className="head-action">
                                <div className="head-title">
                                  
                                </div>
                              </div>
                            </div>
            </div>
          </section>
        </Box> */}
      </Modal>
    </Fragment>
  );
}

export default CategryDeleteSegment;
